module.exports = __webpack_public_path__ + "img/Adding.60ab2ec5.gif";